var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoCommentColumnsSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 99,
    viewBox: "0 0 127 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_577_3783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0066 15.1938C12.2535 15.1938 13.2695 14.1857 13.2695 12.9484C13.2695 11.7112 12.2535 10.7031 11.0066 10.7031C9.75965 10.7031 8.74365 11.7112 8.74365 12.9484C8.74365 14.1857 9.75965 15.1938 11.0066 15.1938Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8669 15.1938C23.1138 15.1938 24.1298 14.1857 24.1298 12.9484C24.1298 11.7112 23.1138 10.7031 21.8669 10.7031C20.62 10.7031 19.604 11.7112 19.604 12.9484C19.604 14.1857 20.62 15.1938 21.8669 15.1938Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6657 15.1938C33.9126 15.1938 34.9287 14.1857 34.9287 12.9484C34.9287 11.7112 33.9126 10.7031 32.6657 10.7031C31.4188 10.7031 30.4028 11.7112 30.4028 12.9484C30.4028 14.1857 31.4188 15.1938 32.6657 15.1938Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66626 96.5906C4.4951 96.5906 1.92432 94.0398 1.92432 90.8933V8.1065C1.92432 4.95999 4.4951 2.40918 7.66626 2.40918H119.326C122.497 2.40918 125.068 4.95999 125.068 8.1065V89.6026C125.068 89.6026 125.291 96.583 118.303 96.583H22.1212C18.619 96.583 15.7789 93.7648 15.7789 90.2899V25.8247H111.221V88.5487",
    stroke: "#B8B5DD",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4077 35.4937H40.5477",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4077 44.1616H48.2446",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4077 52.8296H50.9463",
    stroke: "#4230E5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0054 62.5596H25.6538V86.1737H60.0054V62.5596Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.515 62.5596H67.1636V86.1737H101.515V62.5596Z",
    stroke: "#4230E5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_577_3783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127,
    height: 98,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCommentColumnsSelected);
export default __webpack_public_path__ + "static/media/no-comment-columns-selected.b486d7a0e460ab208947c70ae93ca691.svg";
export { ForwardRef as ReactComponent };